"use client";

import { ChangeEvent, memo } from "react";
import { useLanguage } from "@/app/LanguageContext";
import styles from "../../../Style/ElementStyle/languageSwither.module.css";

interface Language {
  name: string;
  code: string;
}

interface LanguageSwitcherProps {
  languages: Language[];
}

const LanguageSwitcher = ({ languages }: LanguageSwitcherProps) => {
  const { language, setLanguage } = useLanguage();
  console.log(`current language ${language}`);
  const handleChange:any = (e: ChangeEvent<HTMLSelectElement>) => {
    const newLang = e.target.value;
    console.log(`new language ${newLang}`);
    console.log(`[LanguageSwitcher] Switching from ${language} to ${newLang}`);
    setLanguage(newLang);
  };

  return (
    <select
      value={language}
      onChange={handleChange}
      className="bg-transparent text-gray-800 w-[45px] md:w-[72px] h-[23px] p-0 text-sm"
    >
      {languages.map(({ name, code }) => (
        <option
          key={code}
          value={code}
          className={styles.languageOptions}
          style={{
            backgroundColor: code === language ? "lightblue" : "white",
          }}
        >
          {name}
        </option>
      ))}
    </select>
  );
};

export default memo(LanguageSwitcher);
